var React = require('react');

function CheckCircle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10.75 6.5L7.08331 10L5.25 8.25","stroke":"currentColor","strokeWidth":"1.33333","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z","stroke":"currentColor","strokeWidth":"1.33333","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

CheckCircle.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 16 16","fill":"none"};

module.exports = CheckCircle;

CheckCircle.default = CheckCircle;
